import { createContext, useContext } from 'react';
export var context = createContext({
  index: -1,
  size: 'm',
  width: '1',
  first: false,
  last: false
});
export function useGroup() {
  var data = useContext(context);
  return Object.assign(Object.assign({}, data), {
    present: data.index > -1
  });
}